export const APP_NAME = 'PennyClerk'
